module.exports = __webpack_public_path__ + "img/user-2@2x.7d00cab.png";